var m = require('mithril');
var key = require('../../libs/keybindings');
var Model = require('../../libs/Model');
var modal = require('../../layout/components/modal');
var dashboardModel = Object.assign(require('../../../../../models/dashboards/dashboard'), Model);
var Action = Object.create(Model);


Action.editDialogue = function (record, parent, useHasDashboardEdge, options) {
  Action.activeModel = dashboardModel;
  dashboardModel.initForm({
    ...record,
    parent: parent['@rid'], 
    useHasDashboardEdge,
  });
  
  
  var submit = function () {
    Action.activeModel.save()
    .then( response => {
      key.unbind('enter');
      options && options.submitCallback ? options.submitCallback() : '';
      modal.vm.close();
      m.redraw();
    })
  };

  var deleteDashboard = function () {
    Action.activeModel.delete(record)
    .then( response => {
      key.unbind('enter');
      options && options.submitCallback ? options.submitCallback() : '';
      modal.vm.close();
      m.redraw();
    })
  }
  
  key('enter', 'modal', submit);

  modal.vm.title(`${record && record['@rid'] ? 'Edit' : 'Add'} Dashboard:`);
  modal.vm.body = Action.view;

  modal.vm.buttons(
    options && options.delete ? [
      {
        label: "Delete",
        class: 'dib red mr2',
        func: deleteDashboard
      },
      {
        label: "Save",
        class: "dib",
        func: submit
      }
    ] : [
      {
        label: "Save",
        class: "btn-good",
        func: submit
      }
    ]
  );
  var modelOptions={
    extrawidth:true
  }
  modal.vm.open(modelOptions);
}


Action.view = function () {
  return m('form', {role:'form'}, [
    Action.activeModel.errorView() || null,
    Action.activeModel.view()
  ])
}

module.exports = Action;
